import React from 'react'
import {useIntl} from 'react-intl'
import {MenuItem} from './MenuItem'
import {useLocation, useNavigate} from 'react-router-dom'

export function MenuInner() {
  const intl = useIntl()
  const {formatMessage: f} = useIntl()
  const location = useLocation()
  const navigate = useNavigate()

  const titleStyle = {
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '0.02em',
  }

  const handleBackClick = () => {
    const currentPath = location.pathname

    if (currentPath === '/outpatient') {
      navigate('/claims', {
        state: {
          defaultClaimType: 'OUTPATIENT',
          defaultDisplayText: 'Rawat Jalan',
        },
      })
    } else if (currentPath === '/inpatient') {
      navigate('/claims', {
        state: {
          defaultClaimType: 'INPATIENT',
          defaultDisplayText: 'Rawat Inap',
        },
      })
    } else {
      navigate('/claims')
    }
  }

  const getTitle = () => {
    let dynamicTitle = ''

    switch (location.pathname) {
      case '/outpatient':
        dynamicTitle = f({id: 'MENU.APPROVAL'})
        break
      case '/inpatient':
        dynamicTitle = f({id: 'MENU.DIAGNOSIS'})
        break
      case '/claims':
        dynamicTitle = f({id: 'MENU.CLAIM_MANAGEMENT'})
        break
      case '/settlement':
        dynamicTitle = f({id: 'MENU.CLAIM_SETTLEMENT'})
        break
      case '/settlement-detail':
        dynamicTitle = f({id: 'MENU.SETTLEMENT_DETAIL'})
        break
      case '/manual-activation':
        dynamicTitle = f({id: 'MENU.MANUAL_ACTIVATION'})
        break
      default:
        dynamicTitle = ''
    }

    return dynamicTitle ? `${dynamicTitle}` : f({id: 'MENU.DASHBOARD'})
  }

  return (
    <>
      <div style={{display: 'flex', alignItems: 'center', marginBottom: '0'}}>
        {(location.pathname === '/inpatient' || location.pathname === '/outpatient') && (
          <button
            onClick={handleBackClick}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span style={{fontSize: '18px', marginRight: '8px'}}>&#8592;</span>
          </button>
        )}
      </div>
      <MenuItem title={getTitle()} to='/dashboard' titleStyle={titleStyle} />
    </>
  )
}
